import { Reveal } from "./motion";
import { ASSETS } from "./data";

const MobileSection = () => {
  return (
    <section data-testid="mobile-section" className="relative bg-white pt-[56px] pb-0">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 sm:px-8 md:grid-cols-2 md:gap-16">
        <Reveal>
          <h2 className="font-headline text-4xl font-bold leading-[1.03] tracking-tight text-[#0A0E2E] sm:text-5xl md:text-6xl">
            Designed For Mobile Vendors
          </h2>
          <p className="mt-6 text-lg font-medium text-[#0A0E2E] sm:text-xl">
            Your posts already create interest.
          </p>
          <p className="mt-3 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
            eurikaa helps turn that interest into visits by adding your exact location, operating
            hours, and one-tap directions to every post, making it easy for new customers to find
            you wherever you set up.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="md:order-last">
          <img
            src={ASSETS.mobile}
            alt="eurikaa app on a phone showing a food truck event with customer messages"
            className="mx-auto w-full max-w-[500px] drop-shadow-2xl"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default MobileSection;
